// Détection du format d'un CSV (Airbnb / Booking / inconnu) depuis sa
// ligne d'en-tête. Utilisé par les composants d'import UI pour router vers
// le bon parser ou afficher un message d'attente si format non supporté.
//
// Signature :
//   detectCsvFormat(headerLine: string) → 'airbnb' | 'booking' | 'unknown'
//
// Le jour où un parser Booking existera (chantier B), il suffira de brancher
// le nouveau parser sur cette même détection — aucun changement dans l'UI.

function detectCsvFormat(headerLine) {
  if (!headerLine || typeof headerLine !== 'string') return 'unknown'
  // Normalisation : lowercase + suppression des diacritiques + collapse des
  // espaces (insécables U+00A0/U+202F inclus) → les signatures FR matchent que
  // le texte soit déjà dé-mojibaké (cas attendu) ou encore accentué proprement.
  // NB : le dé-mojibake du texte brut se fait en amont (composant d'import) ;
  // cette normalisation est une ceinture de sécurité supplémentaire.
  const h = headerLine
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[\s  ]+/g, ' ')
  // Airbnb (FR et EN) : colonnes spécifiques à Airbnb
  if (h.includes('code de confirmation') || h.includes('confirmation code') || h.includes('frais de menage')) {
    return 'airbnb'
  }
  // Booking : colonnes spécifiques à Booking (présentes chez Booking, absentes
  // d'Airbnb). Signatures EN + FR :
  //   - EN : "payout id" / "payments service fee" / ("reference number" + "reservation status")
  //   - FR : combo "numero de reservation" (ou "numero de reference", vrai
  //          relevé de janvier à mai 2026) + "statut de la reservation"
  //          ou "frais de service de paiement" / "identifiant du paiement"
  if (h.includes('payout id') || h.includes('payments service fee') ||
      (h.includes('reference number') && h.includes('reservation status')) ||
      h.includes('frais de service de paiement') || h.includes('identifiant du paiement') ||
      ((h.includes('numero de reservation') || h.includes('numero de reference')) &&
        h.includes('statut de la reservation'))) {
    return 'booking'
  }
  return 'unknown'
}

module.exports = { detectCsvFormat }
